import RequestPeriodicalPayment from './request-periodical-payment';
export default RequestPeriodicalPayment;
